import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Are you sure you want to delete this service / intervention?")
], -1);
const _hoisted_2 = { class: "columns" };
const _hoisted_3 = { class: "columns" };
const _hoisted_4 = { class: "columns" };
import { CitizenInterventions } from '@minicity/core';
import { ref } from "vue";
import { apiCitizenInterventions } from "./api";
import { doApiAction } from '@/core/api';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitizenInterventionEditorModal',
    props: {
        citizenId: {},
        onModified: { type: Function }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const action = ref("closed");
        const intervention = ref(null);
        __expose({
            create: () => {
                // Create new blank intervention
                action.value = "creating";
                intervention.value = {
                    id: undefined,
                    interventionType: CitizenInterventions.InterventionType['MARTA Card'],
                    cost: 5.00,
                    purpose: "",
                    notes: "",
                    occurredAt: new Date(),
                };
            },
            edit: (i) => {
                action.value = "editing";
                intervention.value = Object.assign({}, i);
            },
            delete: (i) => {
                action.value = "deleting";
                intervention.value = Object.assign({}, i);
            },
        });
        const inProgressAction = ref(null);
        const save = () => {
            switch (action.value) {
                case 'closed': break;
                case 'creating': {
                    doApiAction(inProgressAction, "create", "Added service / intervention", "Failed to add service / intervention", () => apiCitizenInterventions.create(props.citizenId, intervention.value).then(() => close(true)));
                    break;
                }
                case 'editing': {
                    doApiAction(inProgressAction, "update", "Saved service / intervention", "Failed to save service / intervention", () => apiCitizenInterventions.update(props.citizenId, intervention.value).then(() => close(true)));
                    break;
                }
                case 'deleting': {
                    doApiAction(inProgressAction, "delete", "Deleted service / intervention", "Failed to delete service / intervention", () => apiCitizenInterventions.delete(props.citizenId, intervention.value.id).then(() => close(true)));
                    break;
                }
            }
        };
        const close = (wasModified) => {
            action.value = "closed";
            intervention.value = null;
            if (wasModified) {
                props.onModified();
            }
        };
        return (_ctx, _cache) => {
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            const _component_FormSelectField = _resolveComponent("FormSelectField");
            const _component_FormNumberField = _resolveComponent("FormNumberField");
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_FormDateField = _resolveComponent("FormDateField");
            return (action.value == 'deleting')
                ? (_openBlock(), _createBlock(_component_ModalDialog, {
                    key: 0,
                    active: true,
                    loading: inProgressAction.value != null,
                    title: "Delete Service/Intervention",
                    severity: "danger",
                    allowClose: true,
                    onClose: _cache[0] || (_cache[0] = ($event) => (close(false))),
                    firstButtonText: "Cancel",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[1] || (_cache[1] = ($event) => (close(false))),
                    secondButtonText: "Delete",
                    secondButtonSeverity: "danger",
                    onSecondbuttonselected: _cache[2] || (_cache[2] = ($event) => (save()))
                }, {
                    default: _withCtx(() => [
                        _hoisted_1
                    ]),
                    _: 1
                }, 8, ["loading"]))
                : (intervention.value)
                    ? (_openBlock(), _createBlock(_component_ModalDialog, {
                        key: 1,
                        active: true,
                        loading: inProgressAction.value != null,
                        title: intervention.value.id ? 'Edit Service / Intervention' : 'Add Service / Intervention',
                        severity: "link",
                        allowClose: true,
                        onClose: _cache[10] || (_cache[10] = ($event) => (close(false))),
                        firstButtonText: "Cancel",
                        firstButtonSeverity: "link",
                        onFirstbuttonselected: _cache[11] || (_cache[11] = ($event) => (close(false))),
                        secondButtonText: "Save",
                        secondButtonSeverity: "link",
                        onSecondbuttonselected: _cache[12] || (_cache[12] = ($event) => (save()))
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_FormSelectField, {
                                    label: "Type",
                                    options: _unref(CitizenInterventions).InterventionType,
                                    modelValue: intervention.value.interventionType,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((intervention.value.interventionType) = $event)),
                                    disabled: intervention.value.id != undefined
                                }, null, 8, ["options", "modelValue", "disabled"]),
                                _createVNode(_component_FormNumberField, {
                                    label: "Cost ($)",
                                    modelValue: intervention.value.cost,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((intervention.value.cost) = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                                (intervention.value.interventionType == 'MARTA_CARD' || intervention.value.interventionType == 'TRANSPORTATION')
                                    ? (_openBlock(), _createBlock(_component_FormTextField, {
                                        key: 0,
                                        label: "Purpose",
                                        placeholder: "e.g. Social Security appointment",
                                        modelValue: intervention.value.purpose,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((intervention.value.purpose) = $event)),
                                        trimmed: ""
                                    }, null, 8, ["modelValue"]))
                                    : (intervention.value.interventionType == 'OTHER_DOCUMENTS')
                                        ? (_openBlock(), _createBlock(_component_FormTextField, {
                                            key: 1,
                                            label: "Type Of Document",
                                            placeholder: "e.g. Veteran's DD 214",
                                            modelValue: intervention.value.purpose,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((intervention.value.purpose) = $event)),
                                            trimmed: ""
                                        }, null, 8, ["modelValue"]))
                                        : (intervention.value.interventionType == 'OTHER_ASSISTANCE')
                                            ? (_openBlock(), _createBlock(_component_FormTextField, {
                                                key: 2,
                                                label: "Type Of Assistance",
                                                modelValue: intervention.value.purpose,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((intervention.value.purpose) = $event)),
                                                trimmed: ""
                                            }, null, 8, ["modelValue"]))
                                            : _createCommentVNode("", true),
                                _createVNode(_component_FormDateField, {
                                    label: "Occurred At",
                                    modelValue: intervention.value.occurredAt,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((intervention.value.occurredAt) = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_FormTextField, {
                                    label: "Notes",
                                    placeholder: "Enter any other notes here",
                                    modelValue: intervention.value.notes,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((intervention.value.notes) = $event))
                                }, null, 8, ["modelValue"])
                            ])
                        ]),
                        _: 1
                    }, 8, ["loading", "title"]))
                    : _createCommentVNode("", true);
        };
    }
});
